export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLightItalic-Cyrillic-87ecd439c3ca59e04422e6c59b8bd9d2.woff";